import React from 'react'

function Seeyou () {
  return (
    <div
      id='seeyou'
      className='seeyou section-padding bg-img bg-fixed'
    >
      <div className='container'>
        <div className='row'>
          <div className='section-head col-md-12 text-center'>
            <span>
              <i className='ti-heart'></i>
            </span>
            <h4>Já estamos com saudade, hein? Te esperamos lá!</h4>
            <h3>15.08.2026</h3>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Seeyou
